import React from 'react';
import { ModalBackground } from '../../Icons';
export var PromoModalBackground = function (_a) {
    var className = _a.className;
    return (React.createElement("span", { className: className, "aria-hidden": true, role: "presentation" },
        React.createElement(ModalBackground, null)));
};
//# sourceMappingURL=background.js.map